import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || '/api',
  withCredentials: true,
});

// Response interceptor - 401 redirect
api.interceptors.response.use(
  response => response,
  error => {
    if (error.response?.status === 401) {
      const publicPaths = [
        '/',
        '/redefinir-senha',
        '/convite',
        '/cadastro-spk',
        '/termos',
        '/verificacao-2fa',
      ];
      const { pathname } = window.location;
      const isPublicPage = publicPaths.some(
        p => pathname === p || pathname.startsWith(p + '/'),
      );

      if (!isPublicPage) {
        try {
          const { Store } = require('../store');
          const Session = require('../store/actions/session.actions').default;
          Store.dispatch(Session.Logout());
        } catch (_) {}

        window.location.assign('/');
      }
    }

    return Promise.reject(error);
  },
);

export default api;
